import React from 'react';
import './Industry.css';

const Industry = () => {
  return (
    <div className="Industry-Industry-wrapper">
      <div className="Industry-content">
        <h2>Industries de procédés</h2>
        <p>Nous proposons des solutions d’automatisation sur mesure, de supervision et de maintenance conditionnelle pour améliorer l’efficacité et la productivité des industries de transformation.</p>
      </div>
    </div>
  );
};

export default Industry;